<div class="content" *ngIf="leavePolicy$ | async as leavePolicy; else loading">
  <!-- Breadcrumb -->
  <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
    <div class="my-auto mb-2">
      <h2 class="mb-1">Leave Policy Details : {{ leavePolicy.title }}</h2>
      <nav>
        <ol class="breadcrumb mb-0">
          <li class="breadcrumb-item">
            <a href="#!"><i class="ti ti-smart-home"></i></a>
          </li>
          <li class="breadcrumb-item">
            <a [routerLink]="eps.leaves.policiesPath" class="breadcrumb-button">Leave Policy</a>
          </li>
          <li class="breadcrumb-item active" aria-current="page">Leave Policy Details</li>
        </ol>
      </nav>
    </div>
    <div
      class="d-flex my-xl-auto right-content align-items-center flex-wrap"
      *appHasPermission="{ assignedLeavePolicy: ['add'] }"
    >
      <div class="me-2 mb-2">
        <button
          (click)="openBusiness(assignPolicyModal)"
          class="btn btn-primary d-flex align-items-center"
        >
          <i class="ti ti-circle-plus me-2"></i>Assign Policy
        </button>
      </div>
    </div>
  </div>
  <!-- /Breadcrumb -->

  <div class="row">
    <div class="card">
      <div
        class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3"
      >
        <h5>Manage Assignments</h5>
        <div class="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
          <div class="me-3" *ngIf="assignedTo$ | async as assignedTo">
            <select
              data-extension-safe
              class="form-select form-select-sm col-md-1"
              id="entries"
              [(ngModel)]="pageLimit"
              (change)="onPageLimitChange()"
            >
              <!-- <option selected disabled>Show Entries Per Page</option> -->
              <option *ngFor="let limit of [10, 20, 50, 100]" [value]="limit">{{ limit }}</option>
            </select>
          </div>

          <div class="dropdown me-3">
            <select
              class="form-select"
              #statusSelect
              [(ngModel)]="employeeStatus"
              (change)="setCurrentPage(); loadAssignedTo()"
            >
              <option value="" selected>Select Status</option>
              <option value="false">Active</option>
              <option value="true">Inactive</option>
            </select>
          </div>

          <div class="form-sort search-box">
            <label>
              <input
                type="search"
                class="form-control"
                placeholder="Search"
                [(ngModel)]="search"
                (ngModelChange)="onFilterChange()"
            /></label>
          </div>
        </div>
      </div>
      <div class="card-body">
        <!-- <div class="pb-3 d-flex justify-content-between">
          <h3>Manage Assignments</h3>
        </div> -->
        <div class="row">
          <div class="custom-datatable-filter table-responsive">
            <ng-container *ngIf="assignedTo$ | async as assignedTo">
              <ng-container *ngIf="assignedTo.length > 0; else noRecords">
                <table class="table datatable" *ngIf="assignedTo.length > 0">
                  <thead class="thead-light">
                    <tr>
                      <th>Name</th>
                      <th>Available Balance</th>
                      <th>Assigned By</th>
                      <th class="text-end">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let assignment of assignedTo$ | async">
                      <ng-container *ngIf="assignment.user">
                        <td>
                          <div class="d-flex align-items-center">
                            <a
                              [routerLink]="[eps.hrm.employeePath, assignment.user.id]"
                              class="avatar avatar-md"
                              data-bs-toggle="modal"
                              data-bs-target="#view_details"
                            >
                              <!-- <img
                              [src]="
                                assignment.user.picture
                                  ? apiEndpoint + '/uploads/' + assignment.user.picture
                                  : defaultImg
                              "
                              class="img-fluid rounded-circle"
                              alt="img"
                            /> -->
                              <ng-container *ngIf="assignment.user.picture; else initials">
                                <img
                                  [src]="apiEndpoint + '/uploads/' + assignment.user.picture"
                                  class="rounded-circle border border-2"
                                  alt="img"
                                />
                              </ng-container>

                              <ng-template #initials>
                                <span
                                  class="rounded-circle d-inline-flex align-items-center justify-content-center bg-primary text-white fw-bold border border-2"
                                  style="width: 30px; height: 30px"
                                  >{{
                                    getInitials(assignment.user.firstName, assignment.user.lastName)
                                  }}</span
                                >
                              </ng-template>
                            </a>
                            <div class="ms-2">
                              <p class="text-dark mb-0">
                                <a [routerLink]="[eps.hrm.employeePath, assignment.user.id]"
                                  >{{ assignment.user.firstName | capitalize }}
                                  {{ assignment.user.lastName | capitalize }}</a
                                >
                              </p>
                            </div>
                          </div>
                        </td>
                        <td>{{ assignment.currentBalance }}</td>
                        <!-- <td *ngIf="role.roleType === 'Permission Sets'">
                        <span class="d-inline-flex align-items-center">
                          <span *ngIf="!(idForValidUptoUpdate === assignment.id)">
                            {{ assignment.validUpto | date: 'MMM d, yyyy h:mm a' }}
                          </span>

                          <div
                            *ngIf="idForValidUptoUpdate === assignment.id"
                            class="d-inline-flex align-items-center"
                          >
                            <input
                              type="datetime-local"
                              [ngModel]="formatForDateTimeLocal(assignment.validUpto)"
                              (ngModelChange)="TempValidUpto = $event"
                              class="form-control me-2"
                              style="width: auto"
                            />
                            <button class="btn btn-success btn-sm me-2" (click)="saveValidUpto()">
                              <i class="ti ti-check"></i>
                            </button>
                            <button
                              class="btn btn-danger btn-sm"
                              (click)="(idForValidUptoUpdate = '') && (TempValidUpto = null)"
                            >
                              x
                            </button>
                          </div>
                        </span>
                      </td> -->
                        <td>
                          {{
                            assignment.assignBy
                              ? assignment.assignByUser.firstName +
                                ' ' +
                                assignment.assignByUser.lastName
                              : 'Administration'
                          }}
                        </td>
                        <td class="text-end">
                          <div class="action-icon d-inline-flex">
                            <button
                              *appHasPermission="{ assignedLeavePolicy: ['edit'] }"
                              type="button"
                              class="btn btn-icon-style p-1 m-1"
                              aria-label="Edit item"
                              data-bs-toggle="tooltip"
                              title="Update"
                              (click)="editBalance(editBalanceModal, assignment)"
                            >
                              <i class="ti ti-edit"></i>
                            </button>
                            <!-- <ng-container>
                            <a
                              href="javascript:void(0);"
                              (click)="openDelete(deleteModal, policy.id)"
                            >
                              <i class="ti ti-trash"></i>
                            </a>
                          </ng-container> -->
                            <button
                              *appHasPermission="{ assignedLeavePolicy: ['delete'] }"
                              type="button"
                              class="btn btn-icon-style p-1 m-1"
                              (click)="openDelete(deleteModal, assignment.id)"
                              aria-label="Delete item"
                              data-bs-toggle="tooltip"
                              title="Delete"
                            >
                              <i class="ti ti-trash" aria-hidden="true"></i>
                            </button>
                          </div>
                        </td>
                      </ng-container>
                    </tr>
                  </tbody>
                </table>
              </ng-container>
            </ng-container>
            <ng-template #noRecords>
              <div class="text-center">Record not available</div>
            </ng-template>
          </div>
          <!-- pagination -->

          <ng-container *ngIf="assignedTo$ | async as assignedTo">
            <ng-container *ngIf="assignedTo.length > 0">
              <div
                class="d-flex align-items-center justify-content-between ms-2"
                *ngIf="assignedTo.length > 0"
              >
                <div>
                  Showing {{ (currentPage - 1) * pageLimit + 1 }} to {{ pageLastRecord }} of
                  {{ totalCount }} entries
                </div>
                <div class="has-text-centered mt-3">
                  <app-pagination
                    [currentPage]="currentPage"
                    [pageSize]="pageLimit"
                    [totalRows]="totalCount"
                    (pageChange)="onPageChange($event)"
                  ></app-pagination>
                </div>
              </div>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Assign Users Modal -->
<ng-template #assignPolicyModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Assign Leave Policy</h4>
    <button
      type="button"
      class="btn-close custom-btn-close"
      data-bs-dismiss="modal"
      aria-label="Close"
      (click)="onClose()"
    >
      <i class="ti ti-x"></i>
    </button>
  </div>
  <form [formGroup]="assignLeavePolicyform">
    <div class="modal-body pb-0">
      <div class="row">
        <div class="col-md-12">
          <div class="mb-3">
            <div class="input-block mb-3">
              <label for="employeeIds" class="col-form-label"
                >Employees <span class="text-danger">*</span></label
              >
              <ng-select
                class="me-3 w-100"
                [items]="unassignedTo$ | async"
                bindValue="id"
                placeholder="Select Employee"
                [searchable]="true"
                [clearable]="true"
                [multiple]="true"
                [searchFn]="customSearchFnEmployee"
                style="width: 200px"
                formControlName="employeeIds"
              >
                <ng-template ng-label-tmp let-item="item">
                  {{ item.firstName | capitalize }} {{ item.lastName | capitalize }}
                </ng-template>
                <ng-template ng-option-tmp let-item="item">
                  {{ item.firstName | capitalize }} {{ item.lastName | capitalize }}
                </ng-template>
              </ng-select>
              <div
                *ngIf="
                  assignLeavePolicyform.get('employeeIds')?.invalid &&
                  assignLeavePolicyform.get('employeeIds')?.touched
                "
              >
                <span class="text-danger">{{ getErrorMessage('employeeIds') }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-light me-2" data-bs-dismiss="modal" (click)="onClose()">
        Cancel
      </button>
      <button
        type="submit"
        class="btn btn-primary"
        (click)="onAssign()"
        [disabled]="assignLeavePolicyform.invalid"
      >
        Assign
      </button>
    </div>
  </form>
</ng-template>
<!-- /Assign Users Modal -->

<!-- edit leave balance Modal -->
<ng-template #editBalanceModal let-modal *ngIf="leavePolicy$ | async as leavePolicy">
  <div class="modal-header">
    <h4 class="modal-title">Update Available Balance</h4>
    <button
      type="button"
      class="btn-close custom-btn-close"
      data-bs-dismiss="modal"
      aria-label="Close"
      (click)="onClose()"
    >
      <i class="ti ti-x"></i>
    </button>
  </div>
  <form [formGroup]="updateLeavePolicyBalanceForm">
    <div class="modal-body pb-0">
      <div class="row">
        <div class="col-md-12">
          <div class="mb-3">
            <div class="d-flex align-items-center justify-content-between mb-2">
              <span class="d-inline-flex align-items-center">
                <!-- <i class="ti ti-id me-2"></i> -->
                Policy Name
              </span>

              <p>{{ leavePolicy.title }}</p>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="mb-3">
            <div class="d-flex align-items-center justify-content-between mb-2">
              <span class="d-inline-flex align-items-center">
                <!-- <i class="ti ti-id me-2"></i> -->
                Employee Name
              </span>

              <p>{{ editAssignment.user.firstName }} {{ editAssignment.user.lastName }}</p>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="mb-3">
            <div class="d-flex align-items-center justify-content-between mb-2">
              <span class="d-inline-flex align-items-center">
                <!-- <i class="ti ti-id me-2"></i> -->
                Existing Available Balance
              </span>

              <p>{{ editAssignment.currentBalance }}</p>
            </div>
          </div>
        </div>

        <div class="col-md-12">
          <div class="mb-3">
            <div class="input-block mb-3">
              <label for="balance" class="col-form-label"
                >New Available Balance <span class="text-danger">*</span></label
              >
              <input
                class="form-control"
                type="number"
                formControlName="balance"
                appTrimInput
                min="0"
              />

              <div
                *ngIf="
                  updateLeavePolicyBalanceForm.get('balance')?.invalid &&
                  updateLeavePolicyBalanceForm.get('balance')?.touched
                "
              >
                <span class="text-danger">{{ getErrorMessage('balance') }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="mb-3">
            <div class="input-block mb-3">
              <label for="reason" class="col-form-label">Reason </label>
              <textarea
                class="form-control"
                type="text"
                formControlName="reason"
                appTrimInput
              ></textarea>

              <div
                *ngIf="
                  updateLeavePolicyBalanceForm.get('reason')?.invalid &&
                  updateLeavePolicyBalanceForm.get('reason')?.touched
                "
              >
                <span class="text-danger">{{ getErrorMessage('reason') }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-light me-2" data-bs-dismiss="modal" (click)="onClose()">
        Cancel
      </button>
      <button
        type="submit"
        class="btn btn-primary"
        (click)="onUpdateBalance()"
        [disabled]="updateLeavePolicyBalanceForm.invalid"
      >
        Update
      </button>
    </div>
  </form>
</ng-template>
<!-- /edit leave balance Modal -->

<ng-template #loading>
  <!-- <p>Loading business details...</p> -->
  <app-loader></app-loader>
</ng-template>

<!-- Delete Modal -->
<ng-template #deleteModal let-modal>
  <!-- <div class="modal fade" id="delete_modal">
  <div class="modal-dialog modal-dialog-centered modal-sm">
    <div class="modal-content"> -->
  <div class="modal-body text-center">
    <span class="avatar avatar-xl bg-transparent-danger text-danger mb-3">
      <i class="ti ti-trash-x fs-36"></i>
    </span>
    <h4 class="mb-1">Remove Leave Assignment</h4>
    <p class="mb-3">
      Are you sure you want to remove this leave policy assignment from the employee? <br />
      This action will remove any associated leave balance, and <strong>cannot be undone</strong>.
    </p>
    <div class="d-flex justify-content-center">
      <a
        href="javascript:void(0);"
        class="btn btn-light me-3"
        data-bs-dismiss="modal"
        (click)="onClose()"
        >Cancel</a
      >
      <a href="javascript:void(0);" class="btn btn-danger" (click)="confirmDelete()">Yes, Remove</a>
    </div>
  </div>
  <!-- </div>
  </div>
  </div> -->
</ng-template>
<!-- /Delete Modal -->
